"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichTrialWithClinicalTrialsGovData = enrichTrialWithClinicalTrialsGovData;
exports.createSlug = createSlug;
const logger_1 = require("../logger");
function enrichTrialWithClinicalTrialsGovData(trial, study) {
    const nctId = trial?.data?.identification?.nctId;
    logger_1.logger.info(`Starting enrichment with ClinicalTrials.gov data for NCT ID ${nctId}`, "clinicaltrials");
    // Store original values for comparison
    const originalValues = {
        ageGroup: trial.data.eligibility?.ageGroup ? [...trial.data.eligibility.ageGroup] : [],
        criteria: trial.data.eligibility?.criteria || '',
        interventions: trial.data.description?.interventions ? [...trial.data.description.interventions] : [],
        conditions: trial.data.description?.conditions ? [...trial.data.description.conditions] : []
    };
    logger_1.logger.debug(`Original values before enrichment for ${nctId}:`, "clinicaltrials", originalValues);
    const eligibility = trial.data.eligibility;
    // Enrich age group
    const newAgeGroup = study.protocolSection.eligibilityModule?.stdAges || [];
    eligibility.ageGroup = newAgeGroup;
    logger_1.logger.debug(`Age Group enrichment for ${nctId}: ${originalValues.ageGroup.join(', ') || 'empty'} → ${newAgeGroup.join(', ') || 'empty'}`, "clinicaltrials");
    // Enrich eligibility criteria
    const newCriteria = study.protocolSection.eligibilityModule?.eligibilityCriteria || '';
    eligibility.criteria = newCriteria;
    logger_1.logger.debug(`Eligibility Criteria enrichment for ${nctId}: "${originalValues.criteria}" → "${newCriteria}"`, "clinicaltrials");
    // Enrich interventions
    const newInterventions = study.protocolSection?.armsInterventionsModule?.interventions?.map((intervention) => intervention.name) || [];
    trial.data.description.interventions = newInterventions;
    logger_1.logger.debug(`Interventions enrichment for ${nctId}: [${originalValues.interventions.join(', ')}] → [${newInterventions.join(', ')}]`, "clinicaltrials");
    // Enrich conditions
    const newConditions = study.protocolSection.conditionsModule?.conditions || [];
    trial.data.description.conditions = newConditions;
    logger_1.logger.debug(`Conditions enrichment for ${nctId}: [${originalValues.conditions.join(', ')}] → [${newConditions.join(', ')}]`, "clinicaltrials");
    // Summary of enrichment
    const enrichmentSummary = {
        nctId,
        fieldsEnriched: {
            ageGroup: newAgeGroup.length > 0,
            criteria: newCriteria.length > 0,
            interventions: newInterventions.length > 0,
            conditions: newConditions.length > 0
        },
        totalFieldsEnriched: [
            newAgeGroup.length > 0,
            newCriteria.length > 0,
            newInterventions.length > 0,
            newConditions.length > 0
        ].filter(Boolean).length
    };
    logger_1.logger.info(`Completed enrichment for ${nctId} - ${enrichmentSummary.totalFieldsEnriched}/4 fields enriched:`, "clinicaltrials", enrichmentSummary);
    return trial;
}
function createSlug(title) {
    return title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-") // Replace any non-alphanumeric characters with hyphens
        .replace(/^-+|-+$/g, "") // Remove leading and trailing hyphens
        .replace(/-+/g, "-"); // Replace multiple consecutive hyphens with a single hyphen
}
